import React from "react";
import CustomerMasterContainer from "../../container/admin/customer-master";

const CustomerMasterView = () => {
    return <CustomerMasterContainer />;
};

export default CustomerMasterView;
